import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/img/NKT MakeSense_Logo_for screen.png'
import _imports_1 from '../../assets/img/logo-vertical.svg'


const _hoisted_1 = { "data-bs-theme": "" }
const _hoisted_2 = { class: "container main-sidebar" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "ms-bar-logo mx-auto",
  alt: "..."
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "navbar-brand py-2 px-3 mx-auto ms-nav-user-icon NKT-P2",
  href: "#!"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "p-3" }
const _hoisted_8 = { class: "navbar-nav" }

import NavigationItem from './NavItem.vue'
import { onMounted, ref } from 'vue'
import arrow from '@/assets/svg/nav-arrow.svg'
import MsButton from '../general/buttons/MsButton.vue'
import { useUserStore } from '@/stores/UserStore'
import NestedNavItem from './NestedNavItem.vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { watchDebounced } from '@vueuse/core'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const isExpanded = ref(true)
const isExpandedDebounced = ref(isExpanded.value)

var userStore = useUserStore()
const projectStore = useProjectStore()

function toggle() {
  isExpanded.value = !isExpanded.value
}

onMounted(() => {
  isExpandedDebounced.value = isExpanded.value
})

watchDebounced(
  isExpanded,
  (newVal) => {
    isExpandedDebounced.value = newVal
  },
  { debounce: 100 }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass([isExpanded.value ? '' : 'navbar-vertical-sm', "navbar navbar-vertical fixed-start navbar-expand-md navbar-light ms-nav"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            class: _normalizeClass(["navbar-brand ms-brand", isExpanded.value ? '' : 'mt-5']),
            href: "/"
          }, [
            (isExpanded.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "ms-bar-logo-small",
                    alt: "..."
                  }, null, -1)
                ])))
          ], 2),
          (_unref(userStore).isAdminOrHigher)
            ? (_openBlock(), _createElementBlock("a", _hoisted_5, _toDisplayString(_unref(userStore).isMasterAdmin ? 'Master Admin' : 'Admin'), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["text-center", isExpanded.value ? 'mt-4' : 'mt-5'])
          }, [
            _createVNode(MsButton, {
              onClick: toggle,
              "data-toggle": "collapse",
              "data-target": "#content",
              "button-custom-style": "ms-expand-button"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(arrow),
                  class: _normalizeClass([{ rotated: !isExpanded.value }, "icon"])
                }, null, 10, _hoisted_6)
              ]),
              _: 1
            })
          ], 2)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _createVNode(NavigationItem, {
              "is-expanded": isExpanded.value ? isExpandedDebounced.value : isExpanded.value,
              name: 'Home',
              href: "/"
            }, null, 8, ["is-expanded"]),
            _createVNode(NavigationItem, {
              disabled: _unref(projectStore).selectedProject?.alarmLogsDisabled,
              "is-expanded": isExpanded.value ? isExpandedDebounced.value : isExpanded.value,
              name: 'Alarm Log',
              href: "/alarms"
            }, null, 8, ["disabled", "is-expanded"]),
            _createVNode(NavigationItem, {
              "is-expanded": isExpanded.value ? isExpandedDebounced.value : isExpanded.value,
              name: 'Electrical Performance',
              "coming-soon": true,
              disabled: true,
              href: "/performance"
            }, null, 8, ["is-expanded"]),
            _createVNode(NavigationItem, {
              "is-expanded": isExpanded.value ? isExpandedDebounced.value : isExpanded.value,
              name: 'Mechanical & Physical Data',
              disabled: _unref(projectStore).selectedProject?.mechanicalPhysicalDisabled,
              href: "/mechanical"
            }, null, 8, ["is-expanded", "disabled"]),
            _createVNode(NavigationItem, {
              disabled: _unref(projectStore).selectedProject?.marineSurveyDataDisabled,
              "is-expanded": isExpanded.value ? isExpandedDebounced.value : isExpanded.value,
              name: 'Marine Survey Data',
              href: "/survey"
            }, null, 8, ["disabled", "is-expanded"]),
            _createVNode(NavigationItem, {
              disabled: _unref(projectStore).selectedProject?.sparePartsDisabled,
              "is-expanded": isExpanded.value ? isExpandedDebounced.value : isExpanded.value,
              name: 'Spare Parts',
              href: "/spareparts"
            }, null, 8, ["disabled", "is-expanded"]),
            _createVNode(NavigationItem, {
              "is-expanded": isExpanded.value ? isExpandedDebounced.value : isExpanded.value,
              disabled: _unref(projectStore).selectedProject?.documentationDisabled,
              name: 'Documentation',
              href: "/documentation"
            }, null, 8, ["is-expanded", "disabled"]),
            _createVNode(NestedNavItem, {
              "is-expanded": isExpanded.value ? isExpandedDebounced.value : isExpanded.value,
              name: 'Administration',
              href: "/administration",
              onExpand: toggle
            }, null, 8, ["is-expanded"])
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})